import React, { useState, useEffect, useRef,useContext } from 'react';
import {backEndGeneo} from 'tree/treeProvider'
import { listInput } from './listInputDef';
import css from './listInput.module.css'
import {wrMsg} from 'utile'
import {Langue} from 'context'

interface ApiResponse {
  words: string[];
}

function ListInput(props:listInput.props){
 // const [query, setQuery] = useState('');
 const backEnd=useContext(backEndGeneo)

  const [words, setWords] = useState(new Array<{name:string}>());
 // const [loading, setLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const queryLetters=useRef('')
  const lastWord=useRef('')

  const langue=useContext(Langue)

  // Fetch words from the API with debouncing.

    async function loadVille()
    {
        try{
            if(backEnd.length==0)
                return
            if(lastWord.current==queryLetters.current)
                return
            lastWord.current=queryLetters.current
            if(queryLetters.current.trim().length==0)
              return
            const response = await fetch(backEnd+`geneo/places/${encodeURIComponent(queryLetters.current)}`);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            const data: {name:string}[]=await response.json()
            setIsDialogOpen(true)
            setWords(data);
        }catch(error)
        {
            console.log(error)
            debugger
        }
    }

  function startTimer(interval: number) 
  {
    return setInterval(() => {
        loadVille()
    }, interval);
  }
  
  function stopTimer(timerId: any): void {
    clearInterval(timerId);
  }
  
  useEffect(function(){
    if(backEnd.length==0)
        return
    const timer=startTimer(1000)
    return function(){
        stopTimer(timer)
    }
  },[backEnd])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    queryLetters.current=e.target.value;
    props.onChange(e)
  };

  function setTexte(text:string)
  {
    setIsDialogOpen(false)
    props.onTextChange(text)
  } 

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsDialogOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  let erreurVille=""
    if(props.erreur)
        erreurVille="erreurGen"

  return (
    <div ref={containerRef} style={{ position: 'relative' }} className="gprovville">
      <input 
        className={`${erreurVille} gville`}
        type="text"
        placeholder={wrMsg("Ville","City",langue)}
        value={props.value}
        name={props.name}
        onChange={handleInputChange}
      />
      {isDialogOpen && words.length > 0?
        <div className={`${css.liste} glistprov`}>
        
            <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
              {words.map((value, index) => (
                <li key={index}
                    className={`${css.listItem}`}
                    onClick={() => {
                                    setTexte(value.name)
                                   }}
                >
                  {value.name}
                </li>
              ))}
            </ul>
          
        </div>:null
      }
    </div>

)
    }

export default React.memo(ListInput)
